module.exports = __webpack_public_path__ + "static/media/about-us-image.7296ea72.png";